























import { Component, Vue, Prop, Provide } from "vue-property-decorator";
@Component({
  name: "PaymentRecord",
})
export default class PaymentRecord extends Vue {
  @Provide() private columns: Array<Object> = [
    {
      prop: "jsIndex",
      label: "performance.jsIndex",
      width: "80",
      key: "col-1",
    },
    {
      prop: "orderid",
      label: "ticket.loanID",
      //  width: '',
      key: "col-2",
    },
    {
      prop: "repayamount",
      label: "performance.repayAmount",
      //  width: '',
      key: "col-3",
    },
    {
      prop: "ctime",
      label: "performance.businessTime",
      //  width: '',
      key: "col-4",
    },
    {
      prop: "repaytime",
      label: "performance.repayTime",
      //  width: '',
      key: "col-5",
    },
    {
      prop: "notifytime",
      label: "performance.notifyTime",
      //  width: '',
      key: "col-6",
    },
  ];
  @Prop() private tableData: any;
  public get tabledData() {
    return this.tableData;
  }
  // methods
  private sortChange(val: any) {
  }
}
